import Img from './Img'
import { createBuffer, createTex } from '../webgl-helper'
import { BLUR, TYPES } from '../const'
import { mat3, vec2 } from 'gl-matrix'

export default class BlurImg extends Img {
	protected readonly type = TYPES.BLUR_IMG
	private readonly bufferMatrix = mat3.create()
	private readonly bufferResolution = [1920, 1080]
	private delta = [0, 0]
	private blurImgProgram: any
	private deltaLocation: WebGLUniformLocation
	private blurPositionAttributeLocation: GLint
	private blurLocation: WebGLUniformLocation
	private blurMatrixLocation: WebGLUniformLocation
	private writeTex: WebGLTexture
	private readTex: WebGLTexture
	private writeBuffer: WebGLFramebuffer
	private readBuffer: WebGLFramebuffer

	constructor(params) {
		super(params)
	}

	init(gl, imgProgram?, blurImgProgram?) {
		super.init(gl, imgProgram)

		this.blurImgProgram = blurImgProgram
		this.deltaLocation = gl.getUniformLocation(this.blurImgProgram, 'u_delta')
		this.blurPositionAttributeLocation = gl.getAttribLocation(this.blurImgProgram, 'a_position')
		this.blurLocation = gl.getUniformLocation(this.blurImgProgram, 'u_blur')
		this.blurMatrixLocation = gl.getUniformLocation(this.blurImgProgram, 'u_matrix')

		this.writeTex = createTex(gl)
		this.readTex = createTex(gl)

		this.writeBuffer = createBuffer(gl, this.writeTex)
		this.readBuffer = createBuffer(gl, this.readTex)
	}

	drawBuffer(gl, buffer, tex) {
		gl.bindFramebuffer(gl.FRAMEBUFFER, buffer)
		gl.viewport(0, 0, this.bufferResolution[0], this.bufferResolution[1])

		gl.clear(gl.COLOR_BUFFER_BIT)

		gl.bindTexture(gl.TEXTURE_2D, tex)

		gl.useProgram(this.blurImgProgram)

		gl.bindBuffer(gl.ARRAY_BUFFER, this.positionBuffer)
		gl.enableVertexAttribArray(this.blurPositionAttributeLocation)
		gl.vertexAttribPointer(this.blurPositionAttributeLocation, 2, gl.FLOAT, false, 0, 0)

		gl.uniform1f(this.blurLocation, this.transform.blur)
		gl.uniformMatrix3fv(this.blurMatrixLocation, false, this.bufferMatrix)
		gl.uniform2fv(this.deltaLocation, this.delta)

		gl.drawArrays(gl.TRIANGLES, 0, this.len)
	}

	draw(gl) {
		if (!this.visible) return

		gl.clearColor(0, 0, 0, 0)

		mat3.projection(this.bufferMatrix, this.bufferResolution[0], this.bufferResolution[1])
		mat3.scale(
			this.bufferMatrix,
			this.bufferMatrix,
			vec2.set(this.vec2, this.bufferResolution[0], this.bufferResolution[1])
		)

		this.delta = [BLUR, 0]
		this.drawBuffer(gl, this.writeBuffer, this.texture)

		this.delta = [0, BLUR]
		this.drawBuffer(gl, this.readBuffer, this.writeTex)

		gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)

		gl.bindFramebuffer(gl.FRAMEBUFFER, null)
		gl.bindTexture(gl.TEXTURE_2D, this.readTex)
		gl.viewport(0, 0, this.resolution[0], this.resolution[1])

		gl.useProgram(this.program)

		super.setAttributesAndUniforms(gl)

		gl.drawArrays(gl.TRIANGLES, 0, this.len)
		gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA)
		gl.clearColor(1, 1, 1, 1)
	}
}
